const getQueryKey = (query) => {
  if (typeof query !== "object" || query === null) {
    throw new Error("Input must be a non-null object");
  }
  const parts = [];
  const serialize = (value) => {
    if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
      return String(value);
    } else if (Array.isArray(value)) {
      return value.map((item) => String(item)).join("-");
    } else if (typeof value === "object" && value !== null) {
      return Object.keys(value).sort().map((key) => `${key}:${serialize(value[key])}`).join("::");
    } else {
      return String(value);
    }
  };
  const queryKeys = Object.keys(query).sort();
  queryKeys.forEach((key) => {
    const value = query[key];
    if (value === void 0 || typeof value === "object" && value !== null && Object.keys(value).length === 0) return;
    parts.push(`${key}:${serialize(query[key])}`);
  });
  return parts.sort().join("::");
};

export { getQueryKey };
//# sourceMappingURL=src-utils-generic.util.js.map
